export const PROVIDER_EVENTS = {
  DEFAULT_CHAIN_CHANGED: "default_chain_changed",
};
